import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { DATA_ACCESS_TEXT_STYLE, DataAccessText } from './dataAccessTypography';

type CopyFieldProps = {
  label: string;
  value: string;
  hint?: string;
};

export const CopyField: React.FC<CopyFieldProps> = ({ label, value, hint }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="mb-3" style={{ maxWidth: '33%' }}>
      <div className="text-900 fw-semi-bold mb-1" style={DATA_ACCESS_TEXT_STYLE}>
        {label}
      </div>
      {hint && <DataAccessText className="text-700 mb-1">{hint}</DataAccessText>}
      <div className="d-flex align-items-stretch gap-2">
        <div
          className="flex-grow-1 border border-200 rounded-2 px-3 py-2 bg-50 font-monospace text-900"
          style={{ ...DATA_ACCESS_TEXT_STYLE, wordBreak: 'break-all' }}
        >
          {value}
        </div>
        <Button
          variant="outline-success"
          size="sm"
          className="flex-shrink-0 align-self-start"
          onClick={(e) => {
            handleCopy();
            e.currentTarget.blur();
          }}
        >
          <FontAwesomeIcon icon={faCopy} className="me-1" />
          {copied ? 'Copied' : 'Copy'}
        </Button>
      </div>
    </div>
  );
};

type GuideStepProps = {
  step: number;
  title: string;
  children: React.ReactNode;
  imageSrc?: string;
  imageAlt?: string;
};

export const GuideStep: React.FC<GuideStepProps> = ({
  step,
  title,
  children,
  imageSrc,
  imageAlt,
}) => (
  <div className="mb-5">
    <h6 className="text-900 fw-semi-bold mb-2" style={{ fontSize: '1rem' }}>
      {step}. {title}
    </h6>
    <div className="text-700 mb-3" style={DATA_ACCESS_TEXT_STYLE}>
      {children}
    </div>
    {imageSrc && (
      <div
        className="border border-200 rounded-3 overflow-hidden bg-white"
        style={{ maxWidth: '40rem' }}
      >
        <img src={imageSrc} alt={imageAlt ?? ''} className="w-100 d-block" />
      </div>
    )}
  </div>
);
